import { useEffect, useState } from 'react';
import {
  apiListEventLabels,
  apiRestoreLabel,
  type LabelHistoryItem,
} from '../api';
import { fmtTime } from '../lib/format';

interface Props {
  eventPk: number;
  eventId: number;
  onClose: () => void;
  onChanged: () => void;
}

export default function LabelHistoryModal({ eventPk, eventId, onClose, onChanged }: Props) {
  const [labels, setLabels] = useState<LabelHistoryItem[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [busyId, setBusyId] = useState<number | null>(null);

  async function load() {
    setErr(null);
    try {
      const r = await apiListEventLabels(eventPk);
      setLabels(r.labels);
    } catch (e) {
      setErr(String(e));
    }
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [eventPk]);

  async function restore(id: number) {
    setBusyId(id);
    setErr(null);
    try {
      await apiRestoreLabel(id);
      await load();
      onChanged();
    } catch (e) {
      setErr(String(e));
    } finally {
      setBusyId(null);
    }
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <header>
          <h3>標註歷史 — 事件 {eventId}</h3>
          <button className="linkish" onClick={onClose}>關閉</button>
        </header>

        {err && <div className="error">{err}</div>}
        {labels === null ? (
          <p>載入中…</p>
        ) : labels.length === 0 ? (
          <p>尚無任何標註紀錄。</p>
        ) : (
          <table className="grid">
            <thead>
              <tr>
                <th>狀態</th>
                <th>時間 (秒)</th>
                <th>標註者</th>
                <th>建立時間</th>
                <th>刪除時間</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {labels.map(l => (
                <tr key={l.id} className={l.status === 'active' ? 'row-active' : ''}>
                  <td>
                    {l.status === 'active' ? (
                      <span className="badge badge-active">當前</span>
                    ) : (
                      <span className="badge badge-deleted">已刪除</span>
                    )}
                  </td>
                  <td>
                    {l.data.unlabelable ? (
                      <span
                        className="badge badge-deleted"
                        title={l.data.reason || undefined}
                      >
                        無法標記
                      </span>
                    ) : (
                      l.data.time_seconds?.toFixed(3)
                    )}
                  </td>
                  <td>{l.labeler_email ?? '—'}</td>
                  <td>{fmtTime(l.created_at)}</td>
                  <td>{fmtTime(l.deleted_at)}</td>
                  <td>
                    {l.status === 'active' ? (
                      <span className="muted">—</span>
                    ) : (
                      <button
                        disabled={busyId !== null}
                        onClick={() => restore(l.id)}
                      >
                        {busyId === l.id ? '處理中…' : '設為當前'}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
